export default "__VITE_ASSET__CwYnGWyY__"